import script from "./deliOnceImg1.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg1.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg1.vue?vue&type=style&index=0&id=10274dde&lang=less"

const __exports__ = script;

export default __exports__